import { useEffect, useMemo } from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import ProjectSummary from '../ProjectSummary';
import DeviceList from '../DeviceList';
import Logs from '../Logs';
import Alarms from '../Alarms';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';

const DetailEntry = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('summary', { replace: true })
  }, [])
  return null
}

const getCurrentSubPath = (path: string) => {
  if (path.includes('/summary')) return 'summary';
  if (path.includes('/devices')) return 'devices';
  if (path.includes('/logs')) return 'logs';
  if (path.includes('/alarms')) return 'alarms';
}

export default function ProjectDetail({ isHistory = false }: { isHistory?: boolean }) {
  const { pathname } = useLocation();
  const current = getCurrentSubPath(pathname);
  const navigate = useNavigate();
  const items: TabsProps['items'] = useMemo(() =>
    [
      {
        key: 'summary',
        label: '展会总览',
      },
      {
        key: 'devices',
        label: '用电设备管理',
      },
      isHistory ? null : {
        key: 'logs',
        label: '实时数据',
      },
      isHistory ? null : {
        key: 'alarms',
        label: '告警信息',
      },
    ].filter(Boolean) as any, [isHistory]);

  return (
    <>
      <Tabs activeKey={current} items={items} onChange={key => {
        navigate(key)
      }} />
      <Routes>
        <Route path='/' element={<DetailEntry />} />
        <Route path='/summary' element={<ProjectSummary isHistory={isHistory} />} />
        <Route path='/devices' element={<DeviceList isHistory={isHistory} />} />
        <Route path='/logs/:deviceSn?' element={<Logs />} />
        <Route path='/alarms/:deviceSn?' element={<Alarms />} />
      </Routes>
    </>
  )
};